import React from 'react';
import { SettingDisplayText } from 'components/settings/SettingDisplayText';
import { Box, Divider, Typography } from '@mui/material';

interface ISettingDisplayDictionaryEntry {
    label: string;
    value: string;
}

interface SettingDisplayDictionaryProps {
    title: string;
    entries: ISettingDisplayDictionaryEntry[];
}

export const SettingDisplayDictionary: React.FC<SettingDisplayDictionaryProps> = ({ title, entries }) => (
    <Box sx={{ mt: 3, mb: 1 }}>
        <Divider sx={{ mb: 2 }} />
        <Typography variant="subtitle1" sx={{ fontWeight: 'bold', mb: 1 }}>
            {title}
        </Typography>
        {entries.map(({ label, value }) => (
            <SettingDisplayText key={label} title={label} text={value} />
        ))}
    </Box>
);
